import { CSSProperties } from 'react';

import { userInfo } from 'features/user/config/defaults';

import Box from 'shared/components/Box/Box';
import Typography from 'shared/components/Typography/Typography';

type UserNameProps = {
  children: React.ReactNode;
  maxWidth?: CSSProperties['maxWidth'];
};

export const UserName = ({
  children,
  maxWidth = userInfo.maxWidth,
}: UserNameProps) => (
  <Box style={{ maxWidth }}>
    <Typography
      color="black"
      fontWeight="medium"
      type="meta"
      cropped={true}
      dataTestid="participant-info-name"
    >
      {children}
    </Typography>
  </Box>
);
